import moment from 'moment';

export default function (text: string, format: string) {
  if (text) {
    return moment(text).format(format);
  } else {
    return '-';
  }
}
